import { render, staticRenderFns } from "./ItemPanel.vue?vue&type=template&id=f8079bce"
import script from "./ItemPanel.vue?vue&type=script&lang=js"
export * from "./ItemPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports